import React, { useState } from 'react';
import { Instance } from '@popperjs/core';
import { styled } from '@mui/system';
import { Button, CircularProgress } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { lang } from 'src/lang';

import { Image } from './types';

const ImageTooltip = styled(Tooltip)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f6f6fa',
    color: 'rgba(0, 0, 0, 0.87)',
    width: 180,
    padding: '.5rem .7rem',
    a: {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
}));

function ImageElement({
  element,
  onClick,
  isProcessing,
}: {
  element: Image,
  onClick: any,
  isProcessing: boolean,
}) {
  if (!element.author) {
    return (
      <Button
        onClick={onClick}
        disabled={isProcessing}
      >
        <img src={element.url} alt={element.provider_id} />
      </Button>
    );
  }

  const positionRef = React.useRef<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const popperRef = React.useRef<Instance>(null);
  const areaRef = React.useRef<HTMLImageElement>(null);

  const handleMouseMove = (event: React.MouseEvent) => {
    positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  const [loaded, setLoaded] = useState(false);

  return (
    <ImageTooltip
      disableHoverListener={!loaded}
      disableFocusListener
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            try {
              return new DOMRect(
                areaRef.current!.getBoundingClientRect().right + 85,
                positionRef.current.y - 20,
                0,
                0,
              );
            } catch (e) {
              return new DOMRect();
            }
          },
        },
      }}
      title={(
        <>
          {lang('document.upload_dialog.image_tooltip.line_1')}
          {' '}
          <a href={`${element.author.url}?utm_source=pressto&utm_medium=referral`} rel="noreferrer" target="_blank">{element.author.name}</a>
          {' '}
          {lang('document.upload_dialog.image_tooltip.line_2')}
          {' '}
          <a href="https://unsplash.com/?utm_source=pressto&utm_medium=referral" rel="noreferrer" target="_blank">Unsplash</a>
        </>
      )}
    >
      <Button
        onClick={onClick}
        disabled={isProcessing}
      >
        <img
          src={element.url}
          alt={element.provider_id}
          ref={areaRef}
          id={element.provider_id}
          onMouseMove={handleMouseMove}
          onLoad={() => setLoaded(true)}
          style={!loaded ? { visibility: 'hidden' } : {}}
        />
        {!loaded && (
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: '#E3E3E3', display: 'grid', placeItems: 'center', color: '#999999', aspectRatio: '1',
          }}
          >
            <CircularProgress color="inherit" />
          </div>
        )}
      </Button>
    </ImageTooltip>
  );
}

export default ImageElement;
